import { Button } from '@ets-global/b2c-website-ui';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import BaseModal from '../../Base/Modal/BaseModal';

const ChangeTestTypeFilterModal = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();
  const buttons = (
    <Fragment>
      <Button name="button" className={'button--transparent-light'} onClick={onClose} aria-label={t('common.cancel')}>
        <Trans>common.cancel</Trans>
      </Button>

      <Button name="button" onClick={onSubmit} aria-label={t('common.validate')}>
        <Trans>common.validate</Trans>
      </Button>
    </Fragment>
  );

  return (
    <BaseModal
      isOpen
      onClose={onClose}
      title={<Trans>session-search.main.item.warning.change-testtype.voucher-lost.title</Trans>}
      footer={buttons}
    >
      <Trans>session-search.main.item.warning.change-testtype.voucher-lost.content</Trans>
    </BaseModal>
  );
};

ChangeTestTypeFilterModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ChangeTestTypeFilterModal;
